import { Descriptions, Space } from 'antd';
import React from 'react';
import { FormattedDate, FormattedNumber } from 'react-intl';
import { DiscountType } from 'shared/services/prisma/types';
import CurrencyFormat from 'components/CurrencyFormat';
import { getDiscount, getSubtotal } from 'shared/utils/order';

const OrderItemLabel = ({ item }) => {
  const { title, description, startDate, endDate } = item;
  return (
    <>
      {title}
      {description && title && ' - '}
      {description}
      {startDate && endDate && (
        <>
          <br />
          <FormattedDate value={startDate} year="numeric" day="numeric" month="short" />
          {' - '}
          <FormattedDate value={endDate} year="numeric" day="numeric" month="short" />
        </>
      )}
    </>
  );
};

const Order = ({ order }) => {
  const subtotal = getSubtotal(order);
  const discountAmount = getDiscount(order, subtotal);

  return (
    <Descriptions
      title={order.orderNumber ? `Order #${order.orderNumber}` : null}
      bordered
      column={1}
      size="small"
      contentStyle={{ whiteSpace: 'nowrap', textAlign: 'right' }}
    >
      {order.dataSource && (
      <Descriptions.Item label={`Data source - ${order.dataSource}`} />
      )}
      {order?.items.map((item) => (
        <Descriptions.Item key={item.title} label={<OrderItemLabel item={item} />}>
          {item.amount != null && <CurrencyFormat currency={order.currency} value={item.amount * item.quantity} />}
        </Descriptions.Item>
      ))}
      {subtotal > 0 && (
      <Descriptions.Item label={<b>Subtotal</b>}>
        <CurrencyFormat value={subtotal} currency={order.currency} />
      </Descriptions.Item>
      )}
      {discountAmount > 0 && (
      <Descriptions.Item label={(
        <Space>
          Discount
          {order.discountType === DiscountType.Percentage && (
          <FormattedNumber style="percent" maximumFractionDigits={2} value={order.discount / 100} />
          )}
        </Space>
      )}
      >
        <CurrencyFormat value={-discountAmount} currency={order.currency} />
      </Descriptions.Item>
      )}
      {order.monthlyAmount && (
      <Descriptions.Item label={<b>Total / month</b>}>
        <CurrencyFormat value={order.monthlyAmount || 0} currency={order.currency} />
      </Descriptions.Item>
      )}
      <Descriptions.Item label={(
        <>
          <b>Total</b>
          {' '}
          (Excluding applicable VAT)
        </>
      )}
      >
        <CurrencyFormat value={order.amount || 0} currency={order.currency} />
      </Descriptions.Item>
    </Descriptions>
  );
};

export default Order;
